import React from 'react';

const BrowserHistoryContext = React.createContext();

export default BrowserHistoryContext;
